import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private history: string[] = [];
  private initialUrl = '';

  constructor(private router: Router) {
    // Push initial URL
    this.initialUrl = this.router.url;
    this.history.push(this.initialUrl);

    // Listen to navigation events
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.urlAfterRedirects === this.initialUrl) {
          this.history = [];
        }
        if (
          !event.urlAfterRedirects.endsWith('contact-form') &&
          !this.history.includes(event.urlAfterRedirects)
        ) {
          this.history.push(event.urlAfterRedirects);
        }
      }
    });
  }

  canGoBack(): boolean {
    return this.history.length > 1;
  }

  goBack(): void {
    if (this.canGoBack()) {
      // Remove current URL
      this.history.pop();
      // Get previous URL
      const previousUrl = this.history.pop();
      if (previousUrl) {
        this.router.navigateByUrl(previousUrl);
      }
    }
  }
}
